import { GetServerSideProps } from 'next'
import Cookie from 'cookie-universal'

import { SignUpPage, getEmailCookie } from '@mc/persona-client'

import { getPersonaCheckoutServerProps } from 'pages/utils/getPersonaCheckoutServerProps'

const CheckoutSignUpPage = ({
  errorMessage,
  emailCookie,
}: {
  errorMessage?: string
  emailCookie: string | null
}) => <SignUpPage errorMessage={errorMessage} emailCookie={emailCookie} />

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query } = ctx
  const personaProps = await getPersonaCheckoutServerProps(ctx)
  if (personaProps?.redirect) {
    return personaProps
  }

  const cookies = Cookie(ctx.req, ctx.res)
  const emailCookie: string | null = getEmailCookie(cookies) || null

  return {
    props: {
      emailCookie,
      ...(query.error && { errorMessage: query.error }),
    },
  }
}

CheckoutSignUpPage.pageSettings = {
  title: 'MasterClass On Call',
}

export default CheckoutSignUpPage
